import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getModuleMenus } from '../../utilities/api';

export const fetchModuleMenu = createAsyncThunk('moduleMenu/fetch', async (_, { rejectWithValue }) => {
    try {
        const data = await getModuleMenus();
        return data;
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch module menus');
    }
});

const initialState = {
    moduleMenuData: [],
    loading: false,
    error: null,
    selectedModuleGroup: null
};

const modulemenuSlice = createSlice({
    name: 'moduleMenu',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        setSelectedModuleGroup: (state, action) => {
            state.selectedModuleGroup = action.payload;
        },
        resetFilters: (state) => {
            state.selectedModuleGroup = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchModuleMenu.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload;
                const data = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
                state.moduleMenuData = data.map((m) => ({
                    ...m,
                    status: m.status || m.module_menu_status || 'Active'
                }));
            })
            .addCase(fetchModuleMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.moduleMenuData = [];
            });
    }
});

export const { clearError, setSelectedModuleGroup, resetFilters } = modulemenuSlice.actions;

export const selectModuleMenuData = (state) => state.moduleMenu.moduleMenuData;
export const selectLoading = (state) => state.moduleMenu.loading;
export const selectError = (state) => state.moduleMenu.error;
export const selectSelectedModuleGroup = (state) => state.moduleMenu.selectedModuleGroup;

export default modulemenuSlice.reducer;
